import { Component, OnInit } from '@angular/core';
import { AlertService } from '../../services/alerts/alert.service';

@Component({
  selector: 'app-alert',
  templateUrl: './alert.component.html',
  styleUrls: ['./alert.component.css']
})
export class AlertComponent implements OnInit {

  title = '';
  message = '';
  alertClass = 'warning';
  show = false;

  constructor(private alertService: AlertService) {
  }


  ngOnInit() {
    if (localStorage.getItem('isModerator')) {
      this.getSignalMessage();
    } else {
      this.getMessage();
    }
  }

  getMessage() {
    this.alertService.getAdminMessage().then(res => {
      res.subscribe((alert: any) => {
        this.message = alert.message;
        this.title = alert.title;
        this.show = alert.show;
        this.alertClass = alert.alertClass;
        localStorage.setItem('disabledPush', alert.disabledPush);
      });
    });
  }

  getSignalMessage() {
    this.alertService.getSignalMessage().then(res => {
      res.subscribe((alert: any) => {
        this.message = alert.message;
        this.title = alert.title;
        this.show = alert.show;
        this.alertClass = alert.alertClass;
        localStorage.setItem('disabledPush', alert.disabledPush);
      });
    });
  }
}
